import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@itds/elements/index.js';

import H1 from '@brokerage/components/H1';

import CarrierForm from './CarrierForm';

const NewCarrier = () => {
  const navigate = useNavigate();

  const onSave = () => {
    navigate(-1);
  };

  return (
    <Container>
      <H1>New Carrier</H1>

      <CarrierForm carrier={{}} onSave={onSave} />
    </Container>
  );
};

export default NewCarrier;
